import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';

@Component({
  selector: 'td-wb-learn-toolbar-panel',
  templateUrl: 'learn-toolbar-panel.component.html',
  styleUrls: ['learn-toolbar-panel.component.scss'],
  imports: [
    AsyncPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LearnToolbarPanelComponent implements OnInit {
  breakpointChanges$: Observable<BreakpointState>;

  constructor(private mediaQueryService: MediaQueryService) {
  }

  ngOnInit(): void {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.LT_MD);
  }
}

